import { useThemeContext } from '@popup/theme.context';
import React, { useEffect, useState } from 'react';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import { ColorsUtils } from 'src/utils/colors.utils';
export const PreloadedImage = ({ src, alt, className, addBackground, placeholder, symbol, useDefaultSVG, }) => {
    const [image, setImage] = useState();
    const [background, setBackground] = useState('transparent');
    const { theme } = useThemeContext();
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
        return function cleanup() {
            setMounted(false);
        };
    }, []);
    useEffect(() => {
        if (mounted)
            preload();
    }, [src, mounted]);
    const preload = () => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
            if (addBackground) {
                if (symbol) {
                    setBackground(ColorsUtils.getBackgroundColorFromBackend(symbol, theme));
                }
                else {
                    setBackground(ColorsUtils.getBackgroundColorFromImage(img));
                }
            }
            setImage(img);
        };
        img.onerror = () => {
            if (addBackground && useDefaultSVG) {
                setBackground('#e31337');
            }
            else {
                img.src = alt !== null && alt !== void 0 ? alt : '';
            }
        };
    };
    return (React.createElement(React.Fragment, null,
        image && image.src && (React.createElement("img", { src: image.src, className: `${className} ${addBackground ? 'add-background' : ''}`, style: { background: background } })),
        !(image === null || image === void 0 ? void 0 : image.src) && useDefaultSVG && (React.createElement(SVGIcon, { icon: useDefaultSVG, className: `currency-icon is-svg ${addBackground ? 'add-background' : ''}`, background: background })),
        !image && placeholder && (React.createElement("img", { src: placeholder, className: `${className} ${addBackground ? 'add-background' : ''}`, style: { background: background } }))));
};
